import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme';

const PAW_ASSET = require('./paw.svg');

export default class ShowMoreTrigger extends Component {
  constructor(props) {
    super(props);
    this.clickHandler = this.props.handler.bind(this);
    this.styles = StyleSheet.create({
      container: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100vw',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justiyContent: 'flex-end',
        fontFamily: Theme.font_family_secondary,
        fontSize: Theme.font_size_secondary,
        fontWeight: Theme.font_weight_secondary,
        outline: 'none',
      },
      text: {
        display: 'flex',
        flex: 1,
        textTransform: 'uppercase',
        letterSpacing: 2,
        textAlign: 'center',
        color: '#56c5ff',
        fontFamily: Theme.font_family_secondary,
        fontWeight: Theme.font_weight_secondary,
        fontSize: Theme.font_size_secondary + 2,
        marginBottom: 20,
      },
      image_container: {
        position: 'relative',
        display: 'flex',
        overflow: 'hidden',
        transition: 'all 180ms ease-in-out',
        ':hover': {
          paddingTop: 10,
          paddingRight: 30,
          paddingBottom: 0,
          paddingLeft: 30,
        },
        cursor: 'pointer',
        flex: 3,
        alignItems: 'flex-end',
      },
      image: {
        marginBottom: -20,
        display: 'block',
        height: 150,
        transition: 'all 180ms ease-in-out',
        ':hover': {
          scale: 2,
          marginBottom: 0,
          transform: 'scale(1.3,1.1)',
        },
      },
    });
  }

  render() {
    return (
      <div
        className={css(this.styles.container)}
        role="button"
        tabIndex={0}
        onClick={this.clickHandler}>
        <div className={css(this.styles.text)}>Load more dogs</div>
        <div className={css(this.styles.image_container)}>
          <img className={css(this.styles.image)} src={PAW_ASSET} alt="Paw" />
        </div>
      </div>
    );
  }
}

ShowMoreTrigger.defaultProps = {
  handler: () => {},
};

ShowMoreTrigger.propTypes = {
  handler: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/ShowMoreTrigger/index.js